<template>    
  <div v-if="this.loadMe" class="uk-section">
    <div class="uk-margin-top-large uk-container uk-container-center uk-animation-scale-down uk-text-center">
      <h2 class="uk-margin-top">{{this.$store.getters.GetText.personal.title[this.$store.getters.Lang]}}</h2>

      <h3 v-if="user.acept" class="uk-margin-top" :class="checkAcept(user.acept)">{{this.$store.getters.GetText.personal.acept_tru[this.$store.getters.Lang]}}</h3>
      <h3 v-else class="uk-margin-top" :class="checkAcept(user.acept)">{{this.$store.getters.GetText.personal.acept_fal[this.$store.getters.Lang]}}</h3>
      <button v-show='!user.acept' class="uk-button uk-button-primary  uk-margin  uk-width-expand uk-width-1-3" v-on:click="accept">{{this.$store.getters.GetText.personal.accept[this.$store.getters.Lang]}}</button>
      <button v-show='user.acept' class="uk-button uk-button-primary  uk-margin  uk-width-expand uk-width-1-3" v-on:click="accept">{{this.$store.getters.GetText.personal.unaccept[this.$store.getters.Lang]}}</button>
      <div class="uk-child-width-expand@s uk-text-center " uk-grid>
        <!-- First -->
        <div>
          <div class="uk-margin ">
            <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.registration.name[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand ">
                <span class="uk-form-icon " uk-icon="icon: user"></span>
                <input :disabled="edit" v-model="user.name" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="name">
                </div>
            </div>
      <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.country[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon:  world"></span>
                <input :disabled="edit" v-model="user.country" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="country-name">
            </div>
            </div>

        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.work[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: users"></span>
            <input :disabled="edit" v-model="user.work" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="organization" name="work">
        </div>
        </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.phone[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: phone"></span>
            <input  :disabled="edit" v-model="user.phone" class="uk-input  uk-text-center" type="tel" aria-label="Not clickable icon" placeholder="" autocomplete="tel">
        </div>
        </div>
        

        <div class="uk-margin ">
    <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}</label><br>
        <div class="uk-inline uk-width-expand">
        <span class="uk-form-icon " ></span>
        
        <select :disabled="edit" v-model="user.section" class="uk-select uk-text-center" aria-label="{{ this.$store.getters.GetText.registration.section[this.$store.getters.Lang]}}">
          <option  v-for="sect in this.$store.getters.Sections" :value="sect.id" :key="sect.id">{{ sect[this.$store.getters.Lang] }}</option>
        </select>
    </div>
    </div>
        </div>
        <!-- First -->
        <div>
          <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.birt[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: calendar"></span>
                <input :disabled="edit" v-model="user.birthday" class="uk-input  uk-text-center" type="date" aria-label="Not clickable icon" placeholder="" name="bday" autocomplete="bday">
            </div>
            </div> 
            <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.city[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: home"></span>
                <input :disabled="edit" v-model="user.city" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="address-level1" name="city">
            </div>
            </div>
        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.position[this.$store.getters.Lang]}}</label><br>
            <div class="uk-inline uk-width-expand">
            <span class="uk-form-icon " uk-icon="icon: linkedin"></span>
            <input :disabled="edit" v-model="user.position" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" placeholder="" autocomplete="on" name="organization-title">
        </div>
        </div>

        <div class="uk-margin ">
            <label class="uk-form-label" for="form-stacked-text">{{ this.$store.getters.GetText.registration.degree[this.$store.getters.Lang]}}</label><br>
                <div class="uk-inline uk-width-expand">
                <span class="uk-form-icon " uk-icon="icon: bolt"></span>
                <select :disabled="edit" v-model="user.degree" class="uk-select uk-text-center " aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">            
                    <option class="uk-text-center" v-for="(degrees, index) in degree_list[this.$store.getters.Lang]" :key="index" :value="index">
                        {{degrees}}
                    </option>
                </select>
            </div>
            </div>

        <div class="uk-margin ">
        <label class="uk-form-label" for="form-stacked-text">{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}</label><br>
        <div class="uk-inline uk-width-expand">
        <span class="uk-form-icon " ></span>
       
        <select :disabled="edit" v-model="user.form" class="uk-select uk-text-center" aria-label="{{this.$store.getters.GetText.registration.form[this.$store.getters.Lang]}}">
                <option>Offline</option>
                <option>Online</option>
        </select>
    </div>
        </div>        

        </div>
      </div>
      <!-- fin row -->
      <!--
      <div v-if="sucessful" id="alert" class="uk-alert-primary" uk-alert>
        <a class="uk-alert-close" uk-close v-on:click.prevent="sucessful=false"></a>
        <p>{{this.$store.getters.GetText.personal.suc[this.$store.getters.Lang]}}</p>
      </div>
      <div v-if="error" id="alert" class="uk-alert-danger" uk-alert>
        <a class="uk-alert-close" uk-close v-on:click.prevent="error=false"></a>
        <p>{{this.$store.getters.GetText.personal.fail[this.$store.getters.Lang]}}</p>
      </div>
      -->
      <button v-show='edit' class="uk-button uk-button-primary  uk-margin  uk-width-expand uk-width-1-3" v-on:click="this.edit=this.edit?false:true">{{this.$store.getters.GetText.personal.edit[this.$store.getters.Lang]}}</button><br>
      <button v-show='!edit' class="uk-button uk-button-danger  uk-margin  uk-width-expand uk-width-1-3" v-on:click="this.edit=this.edit?false:true">{{this.$store.getters.GetText.personal.cancel[this.$store.getters.Lang]}}</button><br>
      <button v-show='!edit' class="uk-button uk-button-primary  uk-margin  uk-width-expand uk-width-1-3" v-on:click="update">{{this.$store.getters.GetText.personal.save[this.$store.getters.Lang]}}</button><br>
      
      </div>
      </div>
      


</template>
<script>
import api from '@/api';
import UIkit from 'uikit'
export default {
  name: 'UserCard',  
  data(){    
    return{
    loadMe:false,            
    user:null,
    sucessful:false,
    error: false,
    name :  null,
    email :  null,
    email_verify: true,
    password :  null,
    confirm :  null,
    degree :  null,
    country :  null,
    city :  null,
    work :  null,
    position :  null,
    birthday :  null,
    lang :  this.$store.getters.Lang,
    acept :  null,
    role :  1,
    section : null,
    form : null,
    phone : null,            
    filled : false,
    edit: true,

    degree_list:{
                Ru:{1:'Student',2:'Master',3:'Postgraduate',4:'Candidate',5:'Doctor',6:'Corresponding Member',7:'Academician',8:'PHD'},
                En:{1:'Студент',2:'Магистрант',3:'Аспирант',4:'Кандидат наук',5:'Доктор наук',6:' Член-корреспондент РАН',7:'Академик РАН',8:'PHD'}
            }        
    }    
  },
  mounted(){
    //UIkit.alert('#alert').close();

    var $this=this
    api({
        method: 'post',
        url: '/api/auth/me'
        })
        .then(function(response) {            
            $this.$store.commit('SET_USER',response.data)
            $this.user=response.data            
            $this.degree=$this.degree_list[$this.$store.getters.Lang][response.data.degree]    
            $this.$store.commit('SET_ACCESS_DIR',true)        
            $this.loadMe=true
            
        }).catch(error=>{
          error
        });
      //this.$store.commit('SET_Loaded',true)

    //$this.$store.commit('SET_Loaded',true)
    
  },
  methods:{ 
    checkAcept(acept){
      return acept?'uk-text-success':'uk-text-warning'
    },
    accept(){
      this.user.acept=this.user.acept==1?0:1
      this.update()
    } ,  
    update(){
      this.user.lang=localStorage.getItem('localization')=='En'?'Ru':'En'      
      var $this = this
      //$this.$store.commit('SET_Loaded',false)
        this.email_verify=true
        api.post('api/auth/user/update',
        $this.user).
        then(res=>{
          if (res.data.message=='ok'){
            
            $this.edit=true            
            //alert('Information updated')
            $this.sucessful=true
            UIkit.notification({message: '<span >'+this.$store.getters.GetText.personal.suc[this.$store.getters.Lang]+'</span>',status:'success',pos: 'top-center'}) 
            //$this.$store.commit('SET_Loaded',true)
          } else {
            //alert('Error update!')
            console.log(res.data)
            $this.error=true
            UIkit.notification({message: '<span >'+this.$store.getters.GetText.personal.fail[this.$store.getters.Lang]+'</span>',status:'danger',pos: 'top-center'}) 
           // $this.$store.commit('SET_Loaded',true)
          }
        }
        ).catch(function(){
          //alert('Error update!!')
          $this.error=true
          UIkit.notification({message: '<span >'+this.$store.getters.GetText.personal.fail[this.$store.getters.Lang]+'</span>',status:'danger',pos: 'top-center'}) 
          //$this.$store.commit('SET_Loaded',true)
        }
          
        )
        
    }
  }
  }
</script>




